import React from 'react';

interface PageContainerProps
  extends React.HTMLAttributes<HTMLElement> {
  as?: React.ElementType;
}

const PageContainer: React.FC<PageContainerProps> = ({
  children,
  className = '',
  as: Component = 'main',
  ...rest
}) => {
  return (
    <Component className={`page-container ${className}`} {...rest}>
      {children}
    </Component>
  );
};

export default PageContainer;